/**
 * 相关案例: every case related to one — those its authors named, then the
 * library's nearest by meaning.
 */

import { CoachingNavParams } from '@euler/app/flows/coaching';
import { EmptyView } from '@euler/components/EmptyView';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { ScrollView } from 'react-native';
import { CaseCard } from '../../components/CaseCard';
import { CaseCardSkeleton } from '../../components/CaseCardSkeleton';
import { useRelatedCases } from '../../functions/useRelatedCases';

export const CoachingRelatedCasesScreen = wrapNavigatorScreen(
  ({ caseId }: { caseId: string }) => {
    const { rpx } = useResponsiveContext();
    const navigation = useNavigation<StackNavigationProp<CoachingNavParams>>();
    const { state, reload } = useRelatedCases(caseId);
    if (state.kind === 'failed')
      return <EmptyView message="相关案例暂时没加载出来" onRetry={reload} />;
    if (state.kind === 'ready' && !state.cases.length)
      return <EmptyView message="还没有相关案例" />;
    return (
      <ScrollView
        contentContainerStyle={{
          width: '100%',
          maxWidth: rpx(768),
          alignSelf: 'center',
          padding: rpx(16),
          paddingBottom: rpx(40),
          gap: rpx(12),
        }}
      >
        {state.kind === 'loading'
          ? [0, 1, 2].map(index => (
              <CaseCardSkeleton key={index} withFooter={false} />
            ))
          : state.cases.map(card => (
              <CaseCard
                key={card.id}
                card={card}
                onPress={() => navigation.push('case', { caseId: card.id })}
              />
            ))}
      </ScrollView>
    );
  },
  { title: '相关案例' },
);
